export enum Funcionalidades {
  Acciones = 1,
  Perfiles = 2,
  Roles = 3,
  Usuarios = 4,
  Funcionalidades = 5,
  ParametrosSistema = 6,
  ParametrosSistemaCliente = 7,
  Auditoria = 8,
  AuditoriaUsuarios = 274,
  Conductores = 9,
  Clientes = 10,
  EtiquetaVehiculos = 11,
  Flotas = 12,
  GeoCercas = 13,
  GPS = 14,
  CuadraturaOrdenesServicio = 284,
  Mantencion = 15,
  SIM = 16,
  Sitios = 17,
  Vehiculos = 18,
  AuditoriaGeoCercas = 19,
  AuditoriaSecciones = 20,
  AuditoriaTipos = 21,
  CRM = 22,
  Zonas = 23,
  GrupoDeZona = 24,
  FlotasCompartidas = 25,
  GrupoDeInteres = 26,
  LugarInteres = 27,
  Inicio = 28,
  CompartirInformacion = 29,
  UsuariosTransversal = 30,
  AceptarInformacion = 31,
  RolesTransversal = 32,
  PerfilTransversal = 33,
  GrillaHome = 34,
  GrillaActividadHome = 35,
  GrillaActividadDetalle = 36,
  Alertas = 37,
  Informes = 38,
  GrupoDeConductores = 39,
  TipoDeVehiculo = 40,
  Importar = 41,
  Notificaciones = 42,
  TipoLicencia = 43,
  GrillaComunicaciones = 44,
  PautasActividades = 54,
  TipoDeContacto = 55,
  Actividades = 56,
  Talleres = 57,
  Contactos = 58,
  ListaDeDistribucion = 59,
  AlertasBase = 60,
  Odometro = 61,
  Horometro = 62,
  PlanDeMantenimiento = 63,
  Calendarios = 64,
  Proveedor = 65,
  ClienteProveedor = 66,
  TipoMantenimiento = 67,
  Facturacion = 68,
  Solicitudes = 69,
  TipoDeDispositivo = 70,
  TipoDeMedida = 71,
  RecepcionDeActividades = 72,
  Dispositivos = 73,
  Preventivas = 74,
  Correctivas = 75,
  Dashboard = 76,
  HistoricoMantenimiento = 77,
  Descargas = 78,
  ContratoProveedor = 79,
  Chat = 80,
  EnvioDeInformacion = 81,
  ProgramacionInforme = 83,
  FuncionesGlobales = 84,
  Eventos = 86,
  Mensajes = 87,
  Rutas = 88,
  CertificadorBHP = 300,
  ComandoVelocidad = 90,
  CertificadosBase = 91,
  EmitirCertificado = 92,
  ConsultarFolio = 93,
  HomeSugal = 94,
  Cosechadoras = 95,
  BuscaVehiculo = 96,
  HistoricoInforme = 97,
  AsignacionTransportista = 98,
  FormularioSertec = 101,
  conversor = 102,
  DashboardEsmax = 103,
  RepetirDia = 104,

  AlertasVigilanti = 106,
  ConfigurarAlertas = 107,
  ConductoresCopiloto = 108,
  HomeGeneric = 117,
  ConfigurarLanding = 120,
  ClientesConecta = 105,
  CamarasHistorico = 112,
  CamarasEnVivo = 113,
  CamarasVOD = 114,
  CamarasRegistro = 115,
  CamarasHik = 257,
  InformesGenerados = 118,
  DashboardVigilanti = 136,

  Director = 124,
  Mobileye = 125,
  Peajes = 126,
  RoutePlanner = 127,
  MultiFlota = 128,
  Aguas = 129,
  Vendimia = 130,
  Orvis = 131,

  ConfiguracionCamaras = 152,
  EditarVehiculos = 166,

  MedioAmbiente = 188,
  ConfiguracionComandosSMS = 162,
  EnvioComandosSMS = 163,
  ReportesSMS = 164,
  TorreControl = 139,
  CuadraturaFlotas = 116,
  FlotaVehiculo = 132,
  IntegracionVehiculo = 134,
  ClasificacionPatentes = 133,

  CamarasAlerta = 135,

  CamarasDashboard = 119,
  CamarasOperaciones = 138,

  NuevaSolicitud = 99,
  VerFacturacion = 100,
  MisDocumentos = 99,
  MisSolicitudes = 146,
  MisVisitas = 122,

  CertificadosSucursal = 121,
  Ramplas = 137,

  SimSolicitudes = 148,
  Devoluciones = 160,
  ReportesTecnicos = 239,
  OrdenesCompra = 147,
  GrillaReportesConecta = 153,
  Despacho = 151,

  MantenedorProveedores = 155,
  AltasDeServicio = 167,
  DetalleAltasDeServicio = 171,

  MovimientoDispositivos = 180,
  MovimientoDispositivosSeriados = 181,
  MovimientoDispositivosNoSeriados = 182,
  MovimientoDispositivosSim = 183,
  RecepcionEquipos = 186,
  TablasRecepcionEquipos = 189,
  TarifasPeajes = 200,
  ReportesSerie = 150,
  ReporteSerieActiva = 154,

  SimRegistros = 185,
  SimBajaIndividual = 161,
  AltaTecnico = 168,
  MantenedorTelco = 173,
  MantenedorTelcoEditar = 174,
  MantenedorTelcoEditarApn = 175,
  MantenedorTelcoEditarStock = 176,
  MantenedorTelcoCrearPlan = 177,
  MantenedorTelcoCrearApn = 178,
  MantenedorTelcoCrearStock = 179,
  TablaMantenedorProveedores = 184,

  Bitacora = 187,

  MatrizProducto = 190,
  TiposProducto = 191,
  CambiosServicio = 172,
  MantenedorServipag = 192,
  MotivodeBaja = 194,
  SolicitudBajaSimTarjeta = 193,
  TablaSolicitudBajaSimTarjeta = 195,
  PreparacionEquipos = 156,
  PreparacionEquiposNoSeriados = 169,
  PreparacionEquiposSeriados = 170,
  localidad = 201,
  coordinador = 197,
  RegistrarBajaSim = 198,
  TablaSimsRegistrarBajaSim = 199,
  capacitaciones = 203,
  TipoUbicacion = 206,
  SolicitudBajaCliente = 202,
  TablaClientesSolicitudBajaCliente = 204,
  TablaSolicitudBajaClientesCrear = 209,
  detalleAltasServicioTecnico = 207,
  VerificacionBajaCliente = 211,
  TablaSimsVerificacionBajaCliente = 212,
  ReportesNoSeriados = 214,
  ModuloAutorizaciones = 218,
  ConfigAutorizaciones = 217,
  ControlBajaCliente = 215,

  CortaCorriente = 225,
  MantenedorTag = 240,
  ReportesPeajes = 227,
  AdministradorRutas = 228,
  AsignarVehiculosPeajes = 229,
  DashboardPeajes = 230,
  ClientesCanal = 205,
  MapaPeajes = 241,
  ClasificadorPeajes = 269,
  Streamax = 238,
  ListadoEjecutivos = 235,
  ConfiguracionAlarmas = 224,
  TablaEmailsConfiguracionAlarmas = 226,
  TablaEditarSolicitudBajaSimTarjeta = 232,
  TablaSolicitudesRegistrarBajaSim = 233,
  TablaEditarSolicitudBajaCliente = 234,
  VerUbicacion = 248,
  EstructuraComercialCom = 247,
  ConsultaInstalaciones = 246,
  Cotizador = 245,
  ExistenciaTipoEquipo = 242,
  VerDetalleSerie = 243,
  InformePreparacion = 244,

  AsignacionvehiculosWS = 208,
  AsignacionEsquemas = 210,
  EstadoPatente = 219,
  TablaAutorizadoresOrdenCompra = 250,
  CalendarioCamarasHistorico = 251,
  Atenciones = 253,
  MIDAsignacionEsquemas = 254,
  MantenedorEndpoints = 293,

  NDV = 249,
  ModalNDVReservas = 264,
  BajasComerciales = 255,
  EstadoIntegraciones = 220,
  LogEventosMID = 258,
  TablaVerSeriesOrdenDeCompra = 252,
  SolicitudAnulacionVenta = 256,
  SolicitudAnulacionVentaGRILLA = 259,
  Add = 260,
  ModalAdd = 262,

  TelemetriaDashboard = 263,
  InformeTelemetria = 291,
  FugaCombustible = 294,

  InformeGraficoTemperatura = 268,
  tiposEquiposGrillaCodigos = 278,
  AvlTrack = 270,
  OrdenesSerTec = 272,
  conecta_cuadraturas = 265,
  conecta_cuadraturas_detalle = 266,
  AsignacionClienteGps = 277,
  MIDCorteServicio = 275,
  AuditoriaClientes = 281,

  AsignacionMultiFlota = 279,
  BajasCobranza = 282,
  EdicionCertificados = 280,
  MantenedorContratosSIGA = 283,
  MantenedorTransbank = 289,
  AltasCrm = 290,
  AltaCrm = 290,
  MantenedorTramos = 292,

  informesCamaras = 286,
  informesVigilanti = 287,
  informesPeajes = 288,
  informesTelemetria = 291,
  SolicitudStock = 297,
  Contrato = 296,
  DetalleContrato = 298,
  ContratoArchivo = 299,
  AsignacionSitrack = 304,
  asignarmandante = 307,
}
